<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="12">
        <p><b>СРТС прицепа</b></p>
        <upload-document-modal
          ref="uploadDocumentModal"
          name-document="СРТС"
          :data-edit="dataForEdit"
          :source-id="dataForEdit.sourceId"
          :need-additional="false"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { filesValidateMixinChildActions } from '@/mixins/filesValidateMixin'
import UploadDocumentModal from '@/components/Upload/UploadDocumentModal'
import filesMixin from '../Mixins/files'

export default {
  name: 'FileStsTrailer',
  components: { UploadDocumentModal },
  mixins: [filesMixin, filesValidateMixinChildActions],
  data() {
    return {
      dataForEdit: {
        sourceModelName: 'autos',
        sourceId: 0,
        documentType: 'trailer_sts', // СРСТ
      },
      source_model_id: 1,
      filesValidateMixinData: {
        refComponentName: 'uploadDocumentModal',
        errorMessage: 'СРТС прицепа',
        childFilesCountProperty: 'countFiles',
      },
    }
  },
}
</script>

<style scoped></style>
